import React, { useEffect, useRef } from "react";

const images = [
  {
    src: "./assets/v1web.png",
    mobileSrc: "./assets/v1mob.jpeg",
    alt: "",
    title: "",
    description: "",
  },
  {
    src: "./assets/v2web.jpeg",
    mobileSrc: "./assets/v2mob.jpeg",
    alt: "",
    title: "",
    description: "",
  },
  {
    src: "./assets/v3web.png",
    mobileSrc: "./assets/v3mob.jpeg",
    alt: "",
    title: "",
    description: "",
  }
];

const INTERVAL = 5000; // ← change this ONE number to adjust timing

const Home = () => {
  const carouselRef = useRef(null);
  const instanceRef = useRef(null);

  useEffect(() => {
    const init = () => {
      const el = carouselRef.current;
      if (!el || !window.bootstrap) return;

      // Kill any existing instance first
      const old = window.bootstrap.Carousel.getInstance(el);
      if (old) old.dispose();

      // Create exactly ONE instance with JS only — no data-bs-* attributes
      instanceRef.current = new window.bootstrap.Carousel(el, {
        interval: INTERVAL,
        ride: "carousel",
        wrap: true,
        touch: true,
        pause: false,
      });

      instanceRef.current.cycle();
    };

    if (window.bootstrap) {
      init();
    } else {
      const timer = setInterval(() => {
        if (window.bootstrap) { clearInterval(timer); init(); }
      }, 100);
      return () => clearInterval(timer);
    }

    return () => {
      if (instanceRef.current) {
        instanceRef.current.dispose();
        instanceRef.current = null;
      }
    };
  }, []);

  return (
    <>
      {/*
        NO data-bs-ride, data-bs-interval, or data-bs-pause here.
        Mixing data attributes + JS config causes random scroll timing.
        Everything is controlled by the JS instance above only.
      */}
      <div ref={carouselRef} id="homeCarousel" className="carousel slide carousel-fade vk-carousel">
        <div className="carousel-inner vk-inner">
          {images.map((img, idx) => (
            <div key={idx} className={`carousel-item${idx === 0 ? " active" : ""}`}>
              <picture>
                <source srcSet={img.mobileSrc} media="(max-width: 768px)" />
                <img
                  src={img.src}
                  className="vk-img"
                  alt={img.alt}
                  loading={idx === 0 ? "eager" : "lazy"}
                />
              </picture>

              {(img.title || img.description) && (
                <div className="vk-caption">
                  {img.title && <h5 className="vk-title">{img.title}</h5>}
                  {img.description && <p className="vk-desc">{img.description}</p>}
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="carousel-indicators vk-dots">
          {images.map((_, idx) => (
            <button
              key={idx}
              type="button"
              data-bs-target="#homeCarousel"
              data-bs-slide-to={idx}
              className={idx === 0 ? "active" : ""}
              aria-label={`Slide ${idx + 1}`}
            />
          ))}
        </div>
      </div>

      <style>{`
        .vk-carousel {
          border-radius: 12px;
          box-shadow: 0 5px 16px rgba(122,86,58,0.2);
          margin: 12px 12px 0;
          overflow: hidden;
          background: #f5ede0;
        }
        .vk-inner {
          border-radius: 12px;
          overflow: hidden;
        }

        /* Desktop */
        .vk-img {
          display: block;
          width: 100%;
          height: 500px;
          object-fit: cover;
          object-position: center center;
          border-radius: 12px;
        }
        .vk-caption {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          left: 10%;
          max-width: 40%;
        }
        .vk-title {
          font-size: 2rem;
          font-weight: 300;
          color: #f1e6d4;
          text-shadow: 2px 2px 6px rgba(74,31,26,0.9);
          margin-bottom: 8px;
        }
        .vk-desc {
          font-size: 1rem;
          color: #f1e6d4;
          text-shadow: 1px 1px 4px rgba(74,31,26,0.8);
          margin: 0;
        }

        /* Mobile */
        @media (max-width: 768px) {
          .vk-carousel { margin: 8px 8px 0; border-radius: 10px; }

          .vk-img {
            height: auto !important;
            max-height: 260px;
            object-fit: contain;
            object-position: center;
            background-color: #f5ede0;
            border-radius: 10px;
          }

          .vk-caption {
            position: relative;
            top: unset; transform: none; left: unset;
            max-width: 100%;
            padding: 10px 16px;
            text-align: center;
            background: rgba(74,31,26,0.78);
            border-radius: 0 0 10px 10px;
          }
          .vk-title { font-size: 1.3rem; }
          .vk-desc  { font-size: 0.82rem; }
        }

        .carousel-control-prev,
        .carousel-control-next { display: none !important; }

        /* Dots */
        .vk-dots { bottom: 10px; gap: 6px; }
        .vk-dots button {
          width: 8px !important; height: 8px !important;
          border-radius: 50% !important; border: none !important;
          background-color: rgba(255,255,255,0.5) !important;
          opacity: 1 !important; padding: 0 !important;
          margin: 0 3px !important;
          transition: background-color 0.3s, transform 0.3s;
        }
        .vk-dots button.active {
          background-color: #CCA16A !important;
          transform: scale(1.4);
        }

        @media (max-width: 768px) {
          .vk-dots {
            position: relative; bottom: unset;
            margin-top: 8px; margin-bottom: 4px;
            justify-content: center;
          }
          .vk-dots button { background-color: rgba(74,31,26,0.3) !important; }
          .vk-dots button.active { background-color: #8A4B27 !important; }
        }
      `}</style>
    </>
  );
};

export default Home;